import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";

import { store } from "@components/VerticalLayout/store";
import {
    store as generalSettingStore,
    setIsAssociateModalOpened,
    setNumberMultiShopActive,
    setIsArchived,
    setGlobalDataIsUpdated,
    setIsLoading,
    setCountryKeyValue,
    setIsEdited,
} from "./store";
import { setItemsDisable } from "@store";

import { capitalize } from "@helpers/general";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { languages } from "@constants/index";
import {
    apiRequest,
    checkIfLanguageAssociated,
    createLanguageItem,
    languagesOptions,
} from "./hooks";
import ErrorToast from "@components/Common/ErrorTost";
import { ShowSuccessToast } from "./ShowSuccessToast";
import { useFetchGlobal } from "../../../api/hooks";

type ConfirmationAssociatedMessageType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    setDataIsUpdated?: Function;
    setRowData?: Function;
    uploadedImage?: any;
    setLanguageFormState?: any;
};

export function ConfirmationAssociatedMessage({
    isModalOpened,
    setIsModalOpened,
    setDataIsUpdated,
    setRowData,
    uploadedImage,
    setLanguageFormState,
}: ConfirmationAssociatedMessageType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { franchiseID, userID, oneShop, operatorID } = useSnapshot(store);
    const {
        localShop,
        numberMultiShopActive,
        selectedRows,
        ids,
        activeLanguages,
        languageFavored,
        message,
        shopRowData,
        isArchived,
        globalDataIsUpdated,
        languagesData,
    } = useSnapshot(generalSettingStore);

    const uuidUser = localStorage.getItem("uuidUser");

    async function AssociateLanguage() {
        setIsLoading(true);
        toast.dismiss();
        let isReassignment = false;
        let objectData: any = {};
        let shopIds: any = [];
        for (let element of localShop) {
            let associated = checkIfLanguageAssociated(element, shopRowData);
            if (selectedRows.length !== 0) {
                for (let el of selectedRows) {
                    let indexInAssociated =
                        !oneShop && associated !== undefined
                            ? associated.findIndex(
                                  (item: any) => item.Id === el.Id
                              )
                            : -1;
                    let indexInActiveLanguage = !oneShop
                        ? activeLanguages.findIndex(
                              (elt: any) => elt.Id === el.Id
                          )
                        : -1;
                    let indexInFavoredLanguage = !oneShop
                        ? languageFavored.findIndex(
                              (elt: any) => elt.id === el.Id
                          )
                        : -1;
                    if (
                        oneShop ||
                        indexInAssociated === -1 ||
                        (indexInAssociated !== -1 &&
                            (activeLanguages[indexInActiveLanguage].state !==
                                associated[indexInAssociated].isActive ||
                                languageFavored[indexInFavoredLanguage]
                                    .status !==
                                    associated[indexInAssociated].isFavorite))
                    ) {
                        let indexOfLanguage = languagesOptions(t).findIndex(
                            (elt: any) =>
                                elt.label ===
                                JSON.parse(JSON.stringify(el))[t("Language")]
                        );
                        const id: any = el.Id;
                        if (!shopIds.includes(element.toString())) {
                            shopIds.push(element.toString());
                            objectData[element.toString()] = {};
                        }

                        Object.assign(objectData[element.toString()], {
                            ...createLanguageItem(
                                el,
                                id,
                                oneShop
                                    ? true
                                    : activeLanguages.find(
                                          (elt: any) => elt.Id === el.Id
                                      ).state,
                                el.isArchived,
                                oneShop
                                    ? languagesData.length === 0
                                        ? true
                                        : false
                                    : languageFavored.find(
                                          (elt: any) => elt.id === el.Id
                                      ).status,
                                element,
                                languages[indexOfLanguage].label,
                                associated !== undefined
                                    ? associated.findIndex(
                                          (elt: any) => elt.Id === id
                                      ) !== -1
                                    : false
                            ),
                        });
                    }
                }
                if (!oneShop)
                    associated.forEach((el: any) => {
                        let existingFavored = Object.values(
                            objectData
                        ).findIndex(
                            (language: any) => language.isFavorite === true
                        );
                        if (
                            !Object.keys(objectData).includes(el.Id) &&
                            existingFavored !== -1
                        ) {
                            let indexOfLanguage = languagesOptions(t).findIndex(
                                (elt: any) => elt.label === el[t("Language")]
                            );
                            if (!shopIds.includes(element.toString())) {
                                shopIds.push(element.toString());
                                objectData[element.toString()] = {};
                            }
                            Object.assign(objectData[element.toString()], {
                                ...createLanguageItem(
                                    el,
                                    el.Id,
                                    el.shopId === "0" ? true : false,
                                    el.isArchived,
                                    false,
                                    element,
                                    languages[indexOfLanguage].label
                                ),
                            });
                        }
                    });
            }
        }
        let dataLanguage = {
            userId: userID,
            shopId: shopIds,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: objectData,
            isShop: true,
            isAssociate: true,
            isMultiShop: true,
        };
        // eslint-disable-next-line
        Object.values(objectData).forEach((elt: any) => {
            if (elt.isReassignment === true) {
                isReassignment = true;
            }
        });

        try {
            const result: any = await apiRequest(
                dataLanguage,
                fetchGlobal,
                undefined,
                oneShop ? uploadedImage : ""
            );
            if (result.error) {
                throw new Error("error");
            }
            const getItemsDisableUrl: Response = await fetchGlobal(
                `${process.env.REACT_APP_API_V2_URL}/settings/consomation/items?franchiseId=${franchiseID}&shopId=0`,
                {
                    method: "GET",
                }
            );
            const itemsDisable: any = await getItemsDisableUrl;
            if (itemsDisable.error === false) {
                setItemsDisable(itemsDisable.data);
            }
            if (oneShop) {
                setCountryKeyValue("");
                setLanguageFormState !== undefined &&
                    setLanguageFormState((prev: any) => ({
                        ...prev,
                        langue: "",
                        displayName: "",
                        country: "",
                        countryKey: "",
                        uploadedImage: "",
                        numberActive: (prev.numberActive || 0) + 1,
                        advancedDisplayName: {
                            languages: {
                                fr: "",
                                en: "",
                                nl: "",
                                es: "",
                                pt: "",
                                it: "",
                            },
                        },
                        isValidateButtonDisabled: false,
                    }));
            }
            setIsEdited(false);
            ShowSuccessToast(
                `${t(
                    isReassignment
                        ? "The reassignment was successful"
                        : "The assignment was successful"
                )}`
            );
            setNumberMultiShopActive(
                numberMultiShopActive +
                    selectedRows.length * localShop.length -
                    ids
            );
            setDataIsUpdated !== undefined && setDataIsUpdated(true);
            setRowData !== undefined && setRowData([]);
            setGlobalDataIsUpdated(!globalDataIsUpdated);
            setIsLoading(false);
        } catch (e) {
            ErrorToast(`${t("There's an error")}`);
            setIsLoading(false);
        }
    }

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => setIsModalOpened(!isModalOpened)}
            >
                <span>{capitalize(t("Alert"))}</span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {message}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                {isArchived ? (
                    <CustomMainColorButton
                        rounded
                        className="mr-2"
                        variant="primary"
                        onClick={() => {
                            setIsModalOpened(!isModalOpened);
                            setIsArchived(false);
                        }}
                    >
                        {t("Ok")}
                    </CustomMainColorButton>
                ) : (
                    <React.Fragment>
                        <CustomSecondaryColorButton
                            outline
                            variant="light"
                            onClick={() => {
                                setIsModalOpened(!isModalOpened);
                            }}
                            rounded
                        >
                            {t("Cancel")}
                        </CustomSecondaryColorButton>
                        <CustomMainColorButton
                            rounded
                            className="mr-2"
                            variant="primary"
                            onClick={() => {
                                AssociateLanguage();
                                setIsModalOpened(!isModalOpened);
                                setIsAssociateModalOpened(false);
                            }}
                        >
                            {t("Validate")}
                        </CustomMainColorButton>
                    </React.Fragment>
                )}
            </ModalFooter>
        </StyledModal>
    );
}
